module.exports = __webpack_public_path__ + "static/media/ifps_resized.227dd720.jpg";